import styled from 'styled-components';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MapWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 106px;
  z-index: 0;

  .qu-map {
    width: 100%;
    height: 100%;
  }

  ${media.down('phone')`
    .leaflet-control-zoom {
      display: none;
    }`}

  ${media.up('phone')`
    top: 0;
    right: 0;
    bottom: 0;
    left: 416px;
  `};
`;

export const WarningContainer = styled.div`
  left: 0;
  top: 0;
  right: 0;
  background-color: #f6bd04;
  color: white;
  z-index: 1;
  padding: 18px 24px;
  font-size: 16px;
  position: fixed;

  ${media.down('phone')`
    left: 0;
  `}

  ${media.up('phone')`
    left: 416px;
    padding-left: 48px;
  `};
`;

export const BusinessLogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70px;
  background: #fff;
  padding: 10px 0;
  box-shadow: 1px 1px 4px #0000005e;

  ${media.up('phone')`
    display: none;
  `};
`;

export const BusinessLogo = styled.img`
  max-width: 130px;
  max-height: 100%;
`;



// WEBPACK FOOTER //
// ./src/app/styles.js